import { combineReducers } from "redux";
import organizationsReducer, {
  settingsOrganizationsReducer,
  settingsUserOrganizationsReducer,
} from "./organizations";
import userDataReducer from "./userData";
import accountReducer from "./account";
import globalStateReducer from "./globalState";
import membershipsReducer from "./memberships";
import querystringReducer from "./querystring";
import tableReducer from "./ui/table";

import sidebarReducer from "./sidebar";


import accessKeyImportReducer from "./accessKeyImport";

const rootReducer = combineReducers({
  settingsUserOrganizations: settingsUserOrganizationsReducer,
  settingsOrganizations: settingsOrganizationsReducer,
  organizations: organizationsReducer,
  userData: userDataReducer,
  account: accountReducer,
  memberships: membershipsReducer,
  globalState: globalStateReducer,
  querystring: querystringReducer,
  table: tableReducer,
  accessKeyImport: accessKeyImportReducer,
  sidebar: sidebarReducer,
});

export default rootReducer;
